<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="signalElement"
  [showDiscontinuedWarning]="(isDiscontinued$ | async) || false"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
  imageUrl="./assets/leuchttransparente.svg"
>
  <div data-main>
    <app-floorplan-item-group [floorplanItem]="signalElement"></app-floorplan-item-group>
  </div>
  <div data-extended>
    <app-floorplan-signal-element-detail-form [signalElement]="signalElement"></app-floorplan-signal-element-detail-form>
  </div>
</app-floorplan-item-details>
